import React from 'react';

// Compact navy banner at the top of inner pages (About, Contact, legal).
export default function PageHero({ title, lead, image, children }) {
  return (
    <section className={`page-hero${image ? ' page-hero-image' : ''}`} style={image ? { '--hero-image': `url(${image})` } : undefined}>
      <div className="container">
        <h1 className="typo-title">{title}</h1>
        {lead && <p className="page-hero-lead">{lead}</p>}
        {children}
      </div>
    </section>
  );
}
